var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablelast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2915 3.85288C1.2915 3.03383 1.61687 2.24833 2.19603 1.66917C2.77518 1.09002 3.56069 0.764648 4.37974 0.764648H16.7327C17.5517 0.764648 18.3372 1.09002 18.9164 1.66917C19.4955 2.24833 19.8209 3.03383 19.8209 3.85288V14.147C19.8209 14.9661 19.4955 15.7516 18.9164 16.3307C18.3372 16.9099 17.5517 17.2352 16.7327 17.2352H4.37974C3.56069 17.2352 2.77518 16.9099 2.19603 16.3307C1.61687 15.7516 1.2915 14.9661 1.2915 14.147V3.85288Z",
    stroke: "#7F56DA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6445 4.88184H15.7033M13.6445 8.99948H15.7033M5.40918 13.1171H15.7033M5.40918 6.94066C5.40918 7.48669 5.62609 8.01036 6.01219 8.39647C6.3983 8.78257 6.92197 8.99948 7.468 8.99948C8.01404 8.99948 8.53771 8.78257 8.92381 8.39647C9.30991 8.01036 9.52683 7.48669 9.52683 6.94066C9.52683 6.39463 9.30991 5.87096 8.92381 5.48485C8.53771 5.09875 8.01404 4.88184 7.468 4.88184C6.92197 4.88184 6.3983 5.09875 6.01219 5.48485C5.62609 5.87096 5.40918 6.39463 5.40918 6.94066Z",
    stroke: "#7F56DA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablelast);
export default __webpack_public_path__ + "static/media/tablelast.4f52474f0bb03dcbf213c4d3a563f1bb.svg";
export { ForwardRef as ReactComponent };